import React from 'react'
import Navbar from '../inc/Navbar'
import BrochureForm from './BrochureFrom'

function Brochure() {
  return (
    <div>
        <Navbar/>
        <br/>
        <br/>
        <br/>
        <BrochureForm/>
        <br/>
    </div>
  )
}

export default Brochure